import type { BillingTier } from '@zeus/index'
import { Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

/**
 * Consommation de stockage (#180). Écrits à la main en miroir des selectors
 * zeus : `apps/web/src/gql/**` ne se régénère pas.
 */
export type StorageUsage = {
  orgId: string
  orgName?: string | null
  orgSlug?: string | null
  /** Octets occupés. `Float` côté schéma, donc un `number` ordinaire ici. */
  usedBytes: number
  /** `null` = aucun plafond (compte payant). */
  quotaBytes?: number | null
  remainingBytes?: number | null
  plan: BillingTier
  moduleCount: number
  overQuota: boolean
}

const usageSelector = Selector('StorageUsageModel')({
  orgId: true,
  orgName: true,
  orgSlug: true,
  usedBytes: true,
  quotaBytes: true,
  remainingBytes: true,
  plan: true,
  moduleCount: true,
  overQuota: true,
})

/** Consommation de l'organisation connectée (Admin, Formateur). */
export const GQL_STORAGE_USAGE = typedGql('query')({
  storageUsage: usageSelector,
})

/** Consommation de toutes les organisations (SuperAdmin). */
export const GQL_STORAGE_USAGE_BY_ORGANIZATION = typedGql('query')({
  storageUsageByOrganization: usageSelector,
})
